import { RadioButton } from "primereact/radiobutton";
import commonStyle from "../../content/CommonStyles.module.css";

const RadioButtonInput = ({ value, onChange, options }) => {
  return (
    <div className={commonStyle.radioButtonBlock}>
      {options.map((option) => (
        <div key={option.value} className={commonStyle.accountingRadio}>
          <RadioButton
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
          />
          <label className="ml-2">{option.label}</label>
        </div>
      ))}
    </div>
  );
}

export default RadioButtonInput;